import { render, staticRenderFns } from "./UserAudit.vue?vue&type=template&id=cbb4fc22&"
import script from "./UserAudit.vue?vue&type=script&lang=ts&"
export * from "./UserAudit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb4fc22')) {
      api.createRecord('cbb4fc22', component.options)
    } else {
      api.reload('cbb4fc22', component.options)
    }
    module.hot.accept("./UserAudit.vue?vue&type=template&id=cbb4fc22&", function () {
      api.rerender('cbb4fc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mockups/UserAudit.vue"
export default component.exports